<template>
    <div class="quick-view-form">
        <div v-if="obData.messages" class="quick-view-form__text">
            {{ obData.messages.quickBuy }}
        </div>
        <form class="quick-view-form__form def-validation" @submit.prevent="handlerSubmitForm">
            <input
                type="text"
                class="def-input def-tel-mask"
                name="phone"
                placeholder="+38 (XXX) XXX XX XX"
                required
                @input="changeColor"
            >
            <button v-if="obData.messages" type="submit" class="def-button" :class="{'active-button': activeBtn }">
                {{ obData.messages.buyOneClick }}
            </button>
        </form>
    </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
    name: 'quick-view-form',
    props: ['product', 'messages', 'intoBasket'],
    data() {
        return {
            obData: {},
            activeBtn: false,
        }
    },
    computed: {
        id() {
            if (Array.isArray(this.product)) {
                for (let item in this.product) {
                    return this.product[item].offer?.id || this.product[item].item.id;
                }
            }
            return this.product?.offer?.id || this.product?.id;

        }
    },
    methods: {
        ...mapActions({
            basketAdd: 'basket/add',
            basketCreateOrderByOneClick: 'basket/createOrderByOneClick',
        }),
        changeColor({target}) {
            if (target.value.slice(-1) >= 0) {
                this.activeBtn = true;
            } else {
                this.activeBtn = false;
            }
        },
        async handlerSubmitForm({target}) {
            const formData = new FormData(target);
            const phone = formData.get('phone')?.replace(/[+| |(|)]/g, '');

            if (!this.intoBasket) {
                await this.basketAdd(this.id);
            }

            const responseData = await this.basketCreateOrderByOneClick({id: this.id, phone});
            this.$emit('close');
            this.showThanks(responseData);
        },
        showThanks(data) {

            if (data.product !== undefined) {

                fbq('track', 'Purchase',
                    {value: data.product.PRICE, currency: 'UAH'}
                );

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'ecommerce': {
                        'currencyCode': data.product.CURRENCY,
                        'purchase': {
                            'actionField': {
                                'id': data.product.ORDER_ID,
                                'affiliation': 'Love you',
                                'revenue': data.product.ORDER_PRICE,
                                'tax': '',
                                'shipping': data.product.SHIPPING_PRICE,
                                'coupon': ''
                            },
                            'products': [{
                                'name': data.product.NAME,
                                'id': data.product.ID,
                                'price': data.product.PRICE,
                                'brand': 'Love you',
                                'category': '',
                                'variant': data.product.SIZE,
                                'quantity': data.product.QUANTITY,
                                'coupon': ''
                            }]
                        }
                    },
                    'event': 'gtmUaEvent',
                    'gtmUaEventCategory': 'Enhanced Ecommerce',
                    'gtmUaEventAction': 'Purchase',
                    'gtmUaEventNonInteraction': 'True'
                });
            } else {
                console.log('empty data');
            }
            this.$DefModal.show({
                name: 'thanks-for-application',
                width: '368px',
                props: {
                    result: data?.messages,
                    messages: this.obData.messages,
                },
            })
        },
        async getDataForPopup() {
            try {
                if (!this.messages) {
                    const response = await axios(this.product?.detailPage, {params: {api: 'Y'}});
                    if (response.status === 200) {
                        this.obData = response.data;
                    }
                } else {
                    this.obData.messages = this.messages;
                }

            } catch (err) {
                console.error(err);
            }
        },
    },
    created() {
        this.getDataForPopup();
    },
    mounted() {
        // ципляем маску для инпута телефона
        $('body').trigger('init-form');
    }
}
</script>

<style lang="scss" scoped>
.quick-view-form {
    display: flex;
    flex-direction: column;
    background: #F7F8F9;
    margin: 0 -20px 0px;
    padding-left: 20px;
    padding-right: 20px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

    @include point-md {
        flex-direction: row;
        justify-content: space-between;
    }

    &__text {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: rem(16);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
        height: 80px;
        margin-right: 20px;

        @include point-md {
            width: 45%;
        }
        @include point-lg {
            width: auto;
        }
    }

    &__form {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: auto;

        @include point-md {
            height: 80px;
            flex-direction: row;
        }

        input {
            display: block;
            flex-grow: 1;
            margin-bottom: 0;
            @include point-lg {
                width: auto;
            }
        }
    }

    .def-button {
        font-weight: 500;
        font-size: rem(14);
        width: 100%;
        margin-right: 0;
        margin-top: 10px;
        text-transform: uppercase;
        color: var(--text-colour-secondary);
        background: #B8D9EC;
        height: 48px;
        flex-shrink: 0;

        &.active-button {
            color: #fff;
            background-color: var(--border-colour-primary);

            &:hover {
                color: #fff;
            }
        }

        @include point-md {
            width: auto;
            margin-right: 8px;
            margin-top: 0;
        }

        &:hover {
            color: var(--text-colour-secondary);
        }
    }
}
</style>